import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { FormValidationService } from "../shared";
import { MODE } from "../shared/constant";

@Component({
  selector: "question",
  templateUrl: "question.component.html",
  styleUrls: ["question.scss"],
})
export class QuestionComponent {
  @Input() question: any;
  @Input() sectionGroup: any;
  @Input() questions: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked: any;
  @Input() mode: string;
  @Input() campusCode: string;
  @Input() env: any;

  private displayQuestion = true;
  private centralShippingQuestions = true;
  private disableQuestion = false;

  private currentUser: any;
  private responseControl = {};
  private control: any = new FormControl("");
  private controlObject: any = {};
  private controlCollection: any = {};

  private submitClickedSubscription: Subscription;

  private canDisplayDepartmentName: boolean;

  private departmentControl: any;

  private departmentNameQuestion: any;

  constructor(
    private _formValidationService: FormValidationService,
    private route: ActivatedRoute,
  ) {}

  getResponse(event) {}

  onSelectedOtherDepartment(event) {
    this.canDisplayDepartmentName = event;
    this.departmentControl = this._formValidationService.getQuestionControl(
      "fe27168f-a53b-48fd-92fe-c29d6d3df71b",
    );
    this.departmentNameQuestion = this.questions.find(
      (q) => q?.questionSequenceCode === "fe27168f-a53b-48fd-92fe-c29d6d3df71b",
    );
  }

  ngOnInit() {
    this.controlObject = this.getControl(this.question.questionSequenceCode);
    this.control = this._formValidationService.getQuestionControl(
      this.question.questionSequenceCode,
    );
    let parameters = this.question.params;
    if (parameters.required === "conditional") {
      parameters.conditions.forEach((condition) => {
        this.handleBehaviorOfConditionalQuestion(false, condition.behaviors);
        condition.questions.forEach((question) => {
          console.log("question", question);
          console.log("questionSequenceCode", question.questionSequenceCode);
          let control = this._formValidationService.getQuestionControl(
            question.questionSequenceCode,
          );
          if (control === undefined) return;
          console.log("control", control);

          this.controlCollection[question.questionSequenceCode] = control;
          if (this.mode !== MODE.READONLY) {
            this.evaluateConditions(condition, this.controlCollection);
          }
          control.valueChanges.subscribe((response) => {
            this.evaluateConditions(condition, this.controlCollection);
          });
        });
      });
    }
    this.currentUser = this.route.snapshot.data["currentUser"];
    const hasAdminRole = ["ROLE_UCOP_ADMIN", "ROLE_CAMPUS_ADMIN"].includes(
      this.currentUser.role,
    );
    this.centralShippingQuestions = [
      "a18323ba-5e71-11ec-bf64-0616b9a1008b",
      "7525bcff-956e-11ec-bf64-0616b9a1008b",
      "7c53e123-956e-11ec-bf64-0616b9a1008b",
      "7525bcff-956e-11ec-bf64-0616b9a1008b",
      "6b41d6f5-956e-11ec-bf64-0616b9a1008b",
      "e79fe41e-4ec4-4178-b9ca-8720fd7ec594",
      "dc29942e-5e71-11ec-bf64-0616b9a1008b",
    ].includes(this.question.questionCode);

    this.displayQuestion = !(
      this.question.params.required === "conditional" &&
      this.question.iterations &&
      this.question.iterations[0].responseText == null
    );

    if (hasAdminRole && this.centralShippingQuestions) {
      this.disableQuestion = false;
    }
    if (!hasAdminRole && this.centralShippingQuestions) {
      this.disableQuestion = true;
    } else {
      this.disableQuestion = !this.displayQuestion;
    }
  }

  // evaluate conditions
  evaluateConditions(condition: any, controls) {
    let isConditionSatisfy = true;
    condition.questions.forEach((question) => {
      if (question.responses.length > 1) {
        let isControlValid = false;
        for (let i = 0; i < question.responses.length; i++) {
          if (controls[question.questionSequenceCode]) {
            if (
              controls[question.questionSequenceCode].value.indexOf(
                question.responses[i],
              ) !== -1
            ) {
              isControlValid = true;
              break;
            }
          }
        }
        isConditionSatisfy = isConditionSatisfy && isControlValid;
      } else {
        if (controls[question.questionSequenceCode]) {
          isConditionSatisfy =
            isConditionSatisfy &&
            controls[question.questionSequenceCode].value ===
              question.responses[0];
        }
      }
    });
    this.handleBehaviorOfConditionalQuestion(
      isConditionSatisfy,
      condition.behaviors,
    );
  }

  getControl(code) {
    let control = {};
    this.sectionGroup.controls.responses.controls.forEach((response) => {
      if (response.controls.questionSequenceCode.value === code) {
        control = response;
      }
    });
    return control;
  }

  // method to deal with behaviors
  handleBehaviorOfConditionalQuestion(
    isConditionsSatisfy: boolean,
    behaviors: any,
  ) {
    behaviors.forEach((behavior) => {
      if (behavior === "show") {
        this.displayQuestion = isConditionsSatisfy;
        if (!this.displayQuestion) {
          this.sectionGroup.controls.responses.controls.forEach((response) => {
            if (
              response.controls.questionSequenceCode.value ===
              this.question.questionSequenceCode
            ) {
              this.responseControl = response;
              this.control.setValue("");
              this.sectionGroup.controls.responses.controls.splice(
                this.sectionGroup.controls.responses.controls.indexOf(response),
                1,
              );
            }
          });
        } else {
          this.responseControl["response"] = this.control;
          if (
            this.sectionGroup.controls.responses.controls.indexOf(
              this.responseControl,
            ) === -1
          ) {
            this.sectionGroup.controls.responses.push(this.responseControl);
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/question.component.ts